import { createSerializationAdapter } from "@tanstack/router-core"
import type { TsrSerializable } from "@tanstack/router-core"
import type { SerializedEditorState } from "@payloadcms/richtext-lexical/lexical"

// Adapter is registered only to satisfy TanStack Start's ServerFn type machinery
// (TsrSerializable brand for SerializedEditorState). Its runtime path strips
// matched values from the wire even when toSerializable/fromSerializable are
// identity casts, so the test predicate never matches.
export const lexicalEditorStateAdapter = createSerializationAdapter({
  key: "lexical-editor-state",
  test: (_v: unknown): _v is SerializedEditorState => false,
  toSerializable: (v) => v as unknown as SerializedEditorState & TsrSerializable,
  fromSerializable: (v) => v as SerializedEditorState,
})
